async function request(path, parameters)
{
	const response = await fetch(path,
		{
			...parameters,
			credentials: 'include',
			mode: 'cors',
			headers: new Headers({ ...parameters.headers,
				'Content-Type': 'application/json'
			})
		});

	if (!response.ok)
	{
		if (response.status === 403)
		{
			throw new Error();
		}

		let errObj;

		try
		{
			errObj = await response.json();
		}
		catch (err)
		{
			errObj = response;
		}

		throw errObj;
	}

	return response;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default async function(path, parameters={})
{
	const backendBasePrefix = process.env.REACT_APP_BACKEND_BASE_URL || '/api/v1/';

	try
	{
		// eslint-disable-next-line no-console
		const response = await request(backendBasePrefix + path, parameters);

		if (response.headers.has('content-type'))
		{
			const contentType = response.headers.get('content-type');

			if (contentType.includes('application/json') && response.status !== 204)
			{
				return await response.json();
			}
		}

		return await response.text();
	}
	catch (err)
	{
		if (err.status === 401)
		{
			localStorage.clear();

			if (!window.location.pathname.includes('auth'))
			{
				window.location.href = '/auth/signin';
			}
		}
	}
}